export default __webpack_public_path__ + "static/media/playground.0bd2db1a.svg";